/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { CreateOrganizationMutationRequest, CreateOrganizationMutationResponse, CreateOrganization400, CreateOrganization401, CreateOrganization403, CreateOrganization404, CreateOrganization409, CreateOrganization500 } from "../../types/organizationController/CreateOrganization.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createOrganization } from "../../client/organizationController/createOrganization.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createOrganizationMutationKey = () => [{ url: '/api/organizations/' }] as const

export type CreateOrganizationMutationKey = ReturnType<typeof createOrganizationMutationKey>

export function createOrganizationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateOrganizationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createOrganizationMutationKey()
        return mutationOptions<CreateOrganizationMutationResponse, ResponseErrorConfig<CreateOrganization400 | CreateOrganization401 | CreateOrganization403 | CreateOrganization404 | CreateOrganization409 | CreateOrganization500>, {data: CreateOrganizationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createOrganization(data, config)
          },
        })

}

/**
 * @summary Create organization
 * {@link /api/organizations/}
 */
export function useCreateOrganization<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateOrganizationMutationResponse, ResponseErrorConfig<CreateOrganization400 | CreateOrganization401 | CreateOrganization403 | CreateOrganization404 | CreateOrganization409 | CreateOrganization500>, {data: CreateOrganizationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateOrganizationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createOrganizationMutationKey()

          const baseOptions = createOrganizationMutationOptions(config) as UseMutationOptions<CreateOrganizationMutationResponse, ResponseErrorConfig<CreateOrganization400 | CreateOrganization401 | CreateOrganization403 | CreateOrganization404 | CreateOrganization409 | CreateOrganization500>, {data: CreateOrganizationMutationRequest}, TContext>
          

          return useMutation<CreateOrganizationMutationResponse, ResponseErrorConfig<CreateOrganization400 | CreateOrganization401 | CreateOrganization403 | CreateOrganization404 | CreateOrganization409 | CreateOrganization500>, {data: CreateOrganizationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateOrganizationMutationResponse, ResponseErrorConfig<CreateOrganization400 | CreateOrganization401 | CreateOrganization403 | CreateOrganization404 | CreateOrganization409 | CreateOrganization500>, {data: CreateOrganizationMutationRequest}, TContext>
      
}